// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"517178b0","720":"05e12eb5"}[chunkId] + ".chunk.js";
};